import { reactive } from 'vue'
import api from '../../api/v2/api'
import Exam from '../models/exam'
import Category from '../models/category'
import Pagination from '../models/pagination'
import { ApiError } from '../../api/v2/api/base/response'
import { SnackBar } from '../models/other_models'
import { snackBarState } from './snackbar'
interface ListExam {
  list: Exam[],
  categories: Category[],
  isLoading: boolean,
  pagination: Pagination | null,
}
class ExamState {
  isLoading: boolean = false
  saveExamStatusSuccessFlg: Exam | null = null
  redirectNotFoundPage: boolean = false

  listExam: ListExam = {
    list: [],
    categories: [],
    isLoading: false,
    pagination: null,
  }

  listRecommendationExam: ListExam & {
    untestCount: number
  } = {
      list: [],
      categories: [],
      isLoading: false,
      pagination: null,
      untestCount: 0
    }

  async getList(page = 1, categoryId = "") {
    try {
      this.listExam.isLoading = true
      let params = { page: page, categoryId: categoryId}
      const [pagination, exams] = await api.exam.index(params)
      this.listExam.list = exams
      this.listExam.pagination = pagination
    } catch (error) {
      if (error instanceof ApiError) {
        snackBarState.snackbar = new SnackBar(true, error.messages, error.apiStatus)
      } else {
        // Noop
      }
    } finally {
      this.listExam.isLoading = false
    }
  }
  async getRecommendationList(page = 1) {
    try {
      this.listRecommendationExam.isLoading = true
      const [pagination, untestCount, exams] = await api.exam.recommendation({ page: page })
      this.listRecommendationExam.list = exams
      this.listRecommendationExam.pagination = pagination
      this.listRecommendationExam.untestCount = untestCount
    } catch (error) {
      if (error instanceof ApiError) {
        snackBarState.snackbar = new SnackBar(true, error.messages, error.apiStatus)
      } else {
        // Noop
      }
    } finally {
      this.listRecommendationExam.isLoading = false
    }
  }

  async getCategories() {
    try {
      this.listExam.isLoading = true
      this.listExam.categories = await api.category.index()
    } catch (error) {
      if (error instanceof ApiError) {
        snackBarState.snackbar = new SnackBar(true, error.messages, error.apiStatus)
      } else {
        // Noop
      }
    } finally {
      this.listExam.isLoading = false
    }
  }

  async searchExam(examName = "") {
    let params = {exam_name: examName}
    try {
      this.listExam.isLoading = true
      const [pagination, exams] = await api.exam.search(params)
      this.listExam.list = exams
      this.listExam.pagination = pagination
    } catch (error) {
      if (error instanceof ApiError) {
        snackBarState.snackbar = new SnackBar(true, error.messages, error.apiStatus)
      } else {
        // Noop
      }
    } finally {
      this.listExam.isLoading = false
    }
  }

  saveExamStatusSuccess({ exam }) {
    this.saveExamStatusSuccessFlg = exam
  }
  setRedirectNotFoundPage({ status }) {
    this.redirectNotFoundPage = status
  }
}

// Wrap in reactive() for Vue 3 reactivity
export const examState = reactive(new ExamState()) as ExamState
